export const common =
{
  width: '464px',
  height: '64px'
}

export const web =
{
  ...common,

  width: '400px',
  height: '36px'
}

export const tablet =
{
  ...common
}
